const WHATSAPP_URL =
  'https://wa.me/5491150453306?text=%C2%A1Hola%20*VANGUAR%20HR*!%20Quer%C3%ADa%20realizar%20una%20consulta.';

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="wpp-float"
      id="wpp-float"
      title="Escribinos por WhatsApp"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/images/logo-wpp.webp" alt="WhatsApp" />
    </a>
  );
}

export { WHATSAPP_URL };
